function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1905 52l-25 1c-118 0-126-46-219-46-94 0-189 46-263 46-17 0-127-52-217-52-185 0-223 50-325 49-50-15-93-49-190-49-124 0-174 52-291 52S249 7 156 7C103 6 50 21 0 34v235c287 10 609 19 843 26h339l32-35 691 22V52z",
  fill: "#2C9999"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1544 24c22-3 43-7 65-9 21-3 43-4 65-3h8l8 1h2l2 1h4l3 1 4 1 30 8 31 10 15 5 8 2 8 2c-48-14-71-37-136-37-40 0-79 9-117 18zM1287 22l38 10 19 5 20 6c-44-16-119-42-183-42-56 0-99 4-134 11a1085 1085 0 01122-7h10l5 1h15l5 1h5a405 405 0 0178 15zM20 29l72-12a559 559 0 0154-6h9l9 1a221 221 0 0144 5l8 2 9 3 8 3 34 12 35 8C247 32 225 6 156 6 110 6 64 18 20 29zM538 21l38-8a507 507 0 0176-7h38a347 347 0 01110 25l17 6 9 3 9 3C793 26 749 1 666 1c-52 0-92 9-128 20z",
  fill: "#69BCB8"
});

var SvgSeaWave2 = function SvgSeaWave2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1905,
    height: 295,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSeaWave2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sea-wave-2.fedf3f0f.svg";
export { ForwardRef as ReactComponent };